// components/Events/index.js

import Events from './Events';

export default Events;
